export default "__VITE_ASSET__o$gq2AQ0__"